import useCountEcpProjects from "../../swrCustomHooks/useCountEcpProjects"
import {useTranslation} from "react-i18next"
import arrowLeftBlackIcon from "../../assets/icon/arrow-left-black.svg"
import arrowLeftGrey from "../../assets/icon/arrow-left-grey.svg"
import arrowRightBlackIcon from "../../assets/icon/arrow-right-black.svg"
import arrowRightGrey from "../../assets/icon/arrow-right-grey.svg"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"

export default function EcpProjectsFooter() {
    const {t} = useTranslation()
    const {ecpProjectsContext, setEcpProjectsAction} = useEcpProjectsContext()
    const {countEcpProjects, isLoadingCountEcpProjects, isErrorCountEcpProjects} = useCountEcpProjects(ecpProjectsContext.tab)
    const options = []

    try {
        var index = 1
        while (index < (Math.ceil(countEcpProjects / 8) + 1)) {
            options.push({value: index, label: index})
            index++
        }
    } catch {}

    const handlePage = (value) => {
        const selectPage = document.getElementById("selectPage")
        if (value === "-" && ecpProjectsContext.page > 1) {
            selectPage.value = parseInt(ecpProjectsContext.page - 1)
            setEcpProjectsAction({type: "ECP_PROJECTS_SET_PAGE", payload: {page: parseInt(ecpProjectsContext.page) - 1}})
        } else if (value === "+" && ecpProjectsContext.page < Math.ceil(countEcpProjects / 8)) {
            selectPage.value = parseInt(ecpProjectsContext.page + 1)
            setEcpProjectsAction({type: "ECP_PROJECTS_SET_PAGE", payload: {page: parseInt(ecpProjectsContext.page) + 1}})
        }
    }

    if (isErrorCountEcpProjects || isLoadingCountEcpProjects || countEcpProjects.message || countEcpProjects <= 8) return null
    return (
        <>
        <div className="SECTION ECP-PROJECTS-FOOTER">
            <div className="left-content">
                <select id="selectPage" name="selectPage" onChange={(e) => setEcpProjectsAction({type: "ECP_PROJECTS_SET_PAGE", payload: {page: parseInt(e.target.value)}})}>
                    {options.map((option, index) => {
                        if ((index + 1) === ecpProjectsContext.page) {
                            return <option selected key={`option-${index}`} value={option.value}>{option.label}</option>
                        } else {
                            return <option key={`option-${index}`} value={option.value}>{option.label}</option>
                        }
                    })}
                </select>
                <p>sur {Math.ceil(countEcpProjects / 8)} page{Math.ceil(countEcpProjects / 8) >= 2 && "s"}</p>
            </div>
            <div className="right-content">
                <img src={(Math.ceil(countEcpProjects / 8) === 1 || ecpProjectsContext.page === 1) ? arrowLeftGrey : arrowLeftBlackIcon} alt="" onClick={() => handlePage("-")} title={t("Previous page")}/>
                <img src={(Math.ceil(countEcpProjects / 8) === 1 || ecpProjectsContext.page === Math.ceil(countEcpProjects / 8)) ? arrowRightGrey : arrowRightBlackIcon} alt="" onClick={() => handlePage("+")} title={t("Next page")}/>
            </div>
        </div>
        </>
    )
}